export default {
  about: {
    hero: {
      eyebrow: 'O nama',
      title: 'Osobno. Profesionalno. Precizno.',
      lead: '{{name}} predstavlja individualno planiran videonadzor i osobnu skrb iz jednog izvora.',
    },
    story: {
      quote: '„Umjesto prodaje gotovih paketa, svaki se objekt razmatra prema svojim stvarnim potrebama – od željenih područja slike preko točaka montaže do snimanja i postavljanja aplikacije.“',
      p1: '{{name}} vodi {{owner}} – vaš osobni kontakt od prve konzultacije do trajne skrbi. U sigurnosnoj tehnici radi više od 20 godina i realizirao je stotine projekata za privatne i poslovne korisnike.',
      p2: 'Dugogodišnje iskustvo obuhvaća planiranje i ugradnju sustava kamera u obiteljskim kućama, višestambenim zgradama, trgovinama, uredima, ordinacijama, ugostiteljstvu, skladištima, radionicama i proizvodnim površinama. Svaki se projekt razmatra individualno.',
      p3: 'Ovisno o zahtjevima projekta, {{name}} koristi provjerene sustave Hikvision i Safire. Mogu se planirati i rješenja drugih proizvođača.',
      p4: '{{name}} se ne vidi kao puki prodavač, već kao dugoročni partner. Nakon ugradnje ostaje osobni kontakt.',
    },
    owner: {
      subtitle: 'Sigurnosna tehnika iz Hainburga',
      photoPlaceholder: 'Fotografija vlasnika uskoro',
      role: 'Vlasnik i kontakt osoba',
    },
    milestonesTitle: 'Iskustvo koje se osjeti',
    milestones: {
      '0': { year: 'Više od 20 godina', desc: 'Iskustvo u planiranju i ugradnji sustava kamera za privatne i poslovne korisnike u regiji Rhein-Main.' },
      '1': { year: 'Stotine realiziranih projekata', desc: 'Od obiteljskih kuća preko trgovina do velikih poslovnih sustava – svaki projekt individualno planiran.' },
      '2': { year: 'Neovisno o proizvođaču', desc: 'Biramo tehniku koja odgovara vašim zahtjevima, ovisno o projektu, od raznih poznatih proizvođača.' },
    },
    valuesTitle: 'Ono što čini {{name}}',
    values: {
      '0': { title: 'Individualno planiranje', desc: 'Bez gotovih paketa. Svaki se objekt razmatra prema stvarnim potrebama.' },
      '1': { title: 'Stručna provedba', desc: 'Čista ugradnja, ispravno usmjeravanje i profesionalno kabliranje.' },
      '2': { title: 'Digitalno povezivanje', desc: 'Aplikacija, daljinski pristup i obavijesti – postavljeno i objašnjeno.' },
      '3': { title: 'Osobna skrb', desc: 'Jedna kontakt osoba. Pouzdana. I nakon ugradnje.' },
    },
    cta: {
      title: 'Upoznajte nas',
      lead: 'Prvi razgovor bez obveze brzo pokazuje odgovaramo li jedno drugome. Veselimo se upoznati vaš projekt.',
      primary: 'Zakažite termin',
      secondary: 'Česta pitanja',
    },
  },
};